/**
 * @copyright Copyright 2021 Epic Systems Corporation
 * @file Action button on a dashboard widget
 * @module Epic.AppOrchard.Dashboard.WidgetActionButton
 */

import { Button, ButtonProps, Center, ComponentWithAs, Flex, GridItem, SimpleGrid } from "@chakra-ui/react";
import React from "react";

/** Action button on a dashboard widget. Used to keep consistent formatting across buttons */
export const WidgetActionButton: ComponentWithAs<"button", ButtonProps> = (props: ButtonProps) => {
	const { leftIcon, children, ...rest } = props;

	return (
		<Button
			{...rest}
			variant="outline"
			size="sm"
			w="100%"
			whiteSpace="normal"
			h="unset"
			minH="8"
			display="block"
			pt="0.2em"
			pb="0.2em"
		>
			<SimpleGrid columns={12}>
				<GridItem colSpan={{ base: 1, lg: 2 }}>
					<Flex justify="flex-start">{leftIcon}</Flex>
				</GridItem>
				<GridItem colSpan={{ base: 11, lg: 10 }} ml={{ base: "0.5em", lg: "0.25em" }}>
					<Flex justify="flex-start" h="100%">
						<Center>{children}</Center>
					</Flex>
				</GridItem>
			</SimpleGrid>
		</Button>
	);
};
